import { FC, useEffect, useRef } from 'react';
import QrReaderModule from 'react-qr-reader';
import styles from './QrReader.module.scss';

interface Props {
    onScan: (data: string) => void;
    onError: () => void;
    onClose: () => void;
}

const QrReader: FC<Props> = ({ onScan, onError, onClose }) => {
    const wrapperRef = useRef<HTMLDivElement>(null);
    const handleHideDropdown = (event: KeyboardEvent) => {
        if (event.key === 'Escape') onClose();
    };
    const handleClickOutside = (event: Event) => {
        if (
            wrapperRef.current &&
            !wrapperRef.current.contains(event.target as Node)
        )
            onClose();
    };

    useEffect(() => {
        document.addEventListener('keydown', handleHideDropdown, true);
        document.addEventListener('click', handleClickOutside, true);
        return () => {
            document.removeEventListener('keydown', handleHideDropdown, true);
            document.removeEventListener('click', handleClickOutside, true);
        };
    }, []);
    return (
        <div className={styles.QrReader}>
            <div className={styles.QrReaderModule} ref={wrapperRef}>
                <QrReaderModule
                    delay={300}
                    onError={onError}
                    onScan={(res) => {
                        if (res) {
                            onScan(res);
                        }
                    }}
                />
            </div>
        </div>
    );
};

export default QrReader;
